import { Component, Input, EventEmitter, Output, HostListener, ElementRef, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-input-search',
  templateUrl: './input-search.component.html',
  styleUrls: ['./input-search.component.scss']
})

export class InputSearchComponent implements OnInit{

  public DELAY_AUTOCOMPLETE = 600;
  public inputForm = new FormControl();
  public listSearch = [];
  public ListToService = [];
  public textSearch = '';
  public indexScroll = 0;
  public flagInput = false;
  public indexIdValue = -1;
  @Output() public paramsRouterEmit = new EventEmitter();
  @Output() public itemEmit = new EventEmitter();
  @Output() public indexIdEmit = new EventEmitter();
  @Output() public dataSearch = new EventEmitter();
  @Output() public requestClosedModal = new EventEmitter<boolean>();
  @Input() public service;

  constructor(
    private eRef: ElementRef
  ){ }

  ngOnInit() {
    this.searchInput();
  }

  @HostListener('document:click', ['$event'])
  onClick(ev: Event) {
    if (this.flagInput && this.listSearch.length) {
      if (!this.eRef.nativeElement.contains(ev.target)) {
        this.listSearch = [];
        this.flagInput = false;
      }
    }
  }
  
  public searchInput() {
    this.inputForm.valueChanges.pipe(
      distinctUntilChanged(),
    ).subscribe(text => this.requestSearch(text));
  }

  public requestSearch(data: string): void {
    if (data && data.length >= 3) {
      this.flagInput = true;
      this.service.autoComplete(data).subscribe(resp => {
        this.listSearch = resp;
      });
    } else {
      this.flagInput = false;
      this.indexIdValue = -1;
      this.indexIdEmit.emit(-1);
    }
  }

  public formatStrong(data: string): string {
    return data.replace(/<strong>/g, '').replace(/<\/strong>/g, '');
  }

  public downList(event: Event | any) {
    if (event.keyCode === 27) {
      this.flagInput = false;
      return false;
    }
    if ((event.keyCode === 40 || event.keyCode === 38)) {
      if (this.indexFilter(this.indexIdValue, this.listSearch.length, event, 40, 38)) {
        return false;
      }
      this.validIndex(event.keyCode);
    }
  }

  public validIndex(data: number) {
    if (data === 40) {
      this.indexIdValue += 1;
      this.indexIdEmit.emit(this.indexIdValue)
      this.textSearch = this.formatStrong(this.listSearch[this.indexIdValue].description);
      return false;
    }
    if (data === 38) {
      this.indexIdValue -= 1;
      this.indexIdEmit.emit(this.indexIdValue)
      this.textSearch = this.formatStrong(this.listSearch[this.indexIdValue].description);
      return false;
    }
  }

  public indexFilter(index: number, listLength: number, event, numberDown: number, numberUp: number) {
    if ((index + 1 >= listLength) && event.keyCode === numberDown) {
      return true;
    }
    if ((index <= 0) && event.keyCode === numberUp) {
      return true;
    }
    return false;
  }
  
  public searchText() {
    if (this.inputForm.value.length >= 3 || this.ListToService.length) {
      this.listSearch = [];
      this.paramsRouterEmit.emit(this.inputForm.value);
      this.dataSearch.emit(this.ListToService);
      this.flagInput = false;
    } else {
      this.paramsRouterEmit.emit(this.inputForm.value);
      this.flagInput = false;
      this.requestClosedModal.emit(true);
    }
  }

  public sendItem(item) {
    this.itemEmit.emit(item);
    this.flagInput = false;
    this.inputForm.setValue('');
  }

  public pointerSelection(data: number) {
    this.indexIdValue = data;
    this.indexIdEmit.emit(data) ;
  }

}